// import React, { useEffect, useState } from 'react'
// import { Chart as ChartJS, ArcElement, Legend, Colors } from 'chart.js';
// import { Doughnut } from 'react-chartjs-2';

// ChartJS.register(ArcElement, Legend);

// const optionsWorkflow = {
//     responsive: true,
//     plugins: {
//         legend: {
//             display: true,
//             position: 'bottom',
//             labels: {
//                 color: '#9e9e9e'
//             },
//         },
//     },
//     cutout: '60%',
// }

// function WorkflowChart({ workFlowChart }) {

//     console.log(workFlowChart);


//     const totalTasks = (workFlowChart?.todo || 0) +
//         (workFlowChart?.inprogress || 0) +
//         (workFlowChart?.complete || 0) +
//         (workFlowChart?.tododelay || 0) +
//         (workFlowChart?.inprogressDelay || 0) +
//         (workFlowChart?.completeDelay || 0);

//     const hasData = totalTasks > 0;

//     const data = {
//         labels: ['Todo', 'In Progress', 'Completed', 'Todo Delay', 'In Progress Delay', 'Delay Completed'],
//         datasets: [
//             {
//                 data: [workFlowChart && workFlowChart.todo, workFlowChart && workFlowChart.inprogress, workFlowChart && workFlowChart.complete, workFlowChart && workFlowChart.tododelay, workFlowChart && workFlowChart.inprogressDelay, workFlowChart && workFlowChart.completeDelay],
//                 backgroundColor: [
//                     // 'rgb(233, 235, 238)',
//                     'rgb(127, 127, 127)',
//                     'rgb(89, 71, 208)',
//                     'rgb(63, 213, 52)',
//                     'rgb(255, 230, 43)',
//                     'rgb(232, 143, 41)',
//                     'rgb(244, 27, 27)',
//                 ],
//                 borderWidth: 0,
//             },
//         ],
//     };

//     //dark theme image change
//     const [isDarkTheme, setIsDarkTheme] = useState(false);

//     useEffect(() => {
//         // Check for the theme on initial load
//         const currentTheme = document.body.classList.contains("dark-theme");
//         setIsDarkTheme(currentTheme);

//         // Listen for changes to the body's class (if toggling happens outside this component)
//         const observer = new MutationObserver(() => {
//             const updatedTheme = document.body.classList.contains("dark-theme");
//             setIsDarkTheme(updatedTheme);
//         });

//         observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

//         // Cleanup observer on component unmount
//         return () => observer.disconnect();
//     }, []);
//     //dark theme image change end

//     return (
//         <>
//             <div className='card text-center graph-card h-100 mb-0'>
//                 <div className='card-body'>
//                     <h5 className='card-title mb-2'>Work Flow</h5>
//                     {hasData ?
//                         <div className='chart-wrap'>
//                             <Doughnut options={optionsWorkflow} data={data} />
//                         </div> :
//                         <div className='chart-wrap-nodata'>
//                             <img
//                                 src={
//                                     isDarkTheme
//                                         ? `${process.env.PUBLIC_URL}/assets/images/graph-nodata-dark.png`
//                                         : `${process.env.PUBLIC_URL}/assets/images/graph-nodata.png`
//                                 }
//                                 className="img-fluid"
//                                 alt="no-data"
//                             />
//                         </div>

//                     }
//                 </div>
//             </div>
//         </>
//     )
// }

// export default WorkflowChart



import React, { useEffect, useRef, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { Link, useNavigate } from 'react-router-dom';
import ChartPlaceholder from '../../../loader/ChartPlaceholder';
import { UserAuth } from '../../auth/Auth';
import { Modal } from 'react-bootstrap';
import { SuccessMessage, WaringMessage } from '../../../environment/ToastMessage';
import Select from 'react-select'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { PrivateAxios } from '../../../environment/AxiosInstance';
import './ChartCards.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const optionsWorkflow = {
    responsive: true,
    plugins: {
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                color: '#9e9e9e',
                align: 'start', // Left-align the labels
                usePointStyle: true,
                padding: 10,
            },
        },
    },
    cutout: '60%',
};

function WorkflowChart({ workFlowChart, Loading }) {

    const chartRef = useRef(null);
    const navigate = useNavigate();

    const totalTasks = (workFlowChart?.todo || 0) +
        (workFlowChart?.inprogress || 0) +
        (workFlowChart?.overdue || 0);


    const hasData = totalTasks > 0;

    const data = {
        labels: [
            'Todo',
            'In Progress',
            'Overdue',
        ],
        datasets: [
            {
                data: [
                    workFlowChart?.todo || 0,
                    workFlowChart?.inprogress || 0,
                    workFlowChart?.overdue || 0,
                ],
                backgroundColor: [
                    'rgb(100, 207, 92)',
                    'rgb(115, 97, 231)',
                    // 'rgb(63, 213, 52)',
                    'rgb(232, 77, 77)',
                    // 'rgb(232, 143, 41)',
                    // 'rgb(244, 27, 27)',
                ],
                borderWidth: 0,
            },
        ],
    };

    const [isDarkTheme, setIsDarkTheme] = useState(false);

    useEffect(() => {
        const currentTheme = document.body.classList.contains('dark-theme');
        setIsDarkTheme(currentTheme);

        const observer = new MutationObserver(() => {
            const updatedTheme = document.body.classList.contains('dark-theme');
            setIsDarkTheme(updatedTheme);
        });

        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

        return () => observer.disconnect();
    }, []);

    const { MatchPermission, companyInfoGlobal, User } = UserAuth();

    useEffect(() => {
        const chart = chartRef.current;

        if (!chart) return;

        chart.options.onClick = (event, elements) => {
            if (elements.length > 0) {
                const index = elements[0].index;
                const label = data.labels[index];

                // Navigate based on the clicked label
                // switch (label) {
                //     case 'Todo':
                //         navigate('/flow');
                //         break;
                //     case 'In Progress':
                //         navigate('/flow');
                //         break;
                //     case 'Completed':
                //         navigate('/flow');
                //         break;
                //     case 'Todo Delay':
                //         navigate('/flow');
                //         break;
                //     case 'In Progress Delay':
                //         navigate('/flow');
                //         break;
                //     case 'Delay Completed':
                //         navigate('/flow');
                //         break;
                //     default:
                //         break;
                // }
            }
        };
    }, [navigate, data]);

    const observeRef = useRef(null);
    const ObserveSearchRef = useRef(null)
    const [showCreateWorkFlowModal, setShowCreateWorkFlowModal] = useState(false);
    const handleCloseCreateWorkFlowModal = () => setShowCreateWorkFlowModal(false);
    const handleShowCreateWorkFlowModal = () => setShowCreateWorkFlowModal(true);
    const [FlowData, setFlowData] = useState({
        "name": "",
        "observer": 0,
        "observerName": "",
        "desc": "",
        "link": "",
        "permission_user": ""
    })
    const getObserver = (id, name) => {
        setFlowData({ ...FlowData, observer: id, observerName: name });
        if (observeRef.current) {
            observeRef.current.click();
        }
        ObserveSearchRef.current.value = ""
        setObserve(User)
    }

    const [observe, setObserve] = useState(User)
    const searchObserver = (e) => {
        const filteredItems = User.filter((item) => {
            return item && item.name && item.name.toLowerCase().replace(/\s+/g, '').includes(e.target.value.toLowerCase().replace(/\s+/g, ''))
        }
        );
        setObserve(filteredItems);
    }
    const CreateFlow = (e) => {
        e.preventDefault();
        if (FlowData.name == '') {
            WaringMessage("please select flow name")
            return;
        }

        PrivateAxios.post("fms/create", FlowData)
            .then((res) => {
                SuccessMessage(res.data.msg)
                setFlowData({
                    ...FlowData,
                    "name": "",
                    "observer": 0,
                    "observerName": "",
                    "desc": "",
                    "link": "",
                    "permission_user": ""
                })
                // setAssignByMeTableData((prevData) => [res.data.data, ...prevData]);
                // setAssignByMeTableMailData((prevData) => [res.data.data, ...prevData])
            }).catch((err) => {


            })
        handleCloseCreateWorkFlowModal()

    }



    return (
        <>
            <div className="text-center graph-card h-100 mb-0">
                <div className="card-body">
                    <h6 className="text-muted mb-3">Workflow <span className='small'>(Dependent Task)</span></h6>
                    {Loading ?
                        <ChartPlaceholder /> :
                        <>
                            {hasData ? (
                                <div className="chart-wrap">
                                    <Doughnut ref={chartRef} options={optionsWorkflow} data={data} />
                                    <p className='mb-0 mt-1'>Select / Deselect legends</p>

                                </div>
                            ) : (
                                <div className="chart-wrap-nodata">
                                    <img
                                        src={
                                            isDarkTheme
                                                ? `${process.env.PUBLIC_URL}/assets/images/graph-nodata-dark.png`
                                                : `${process.env.PUBLIC_URL}/assets/images/graph-nodata.png`
                                        }
                                        className="img-fluid"
                                        alt="no-data"
                                    />
                                </div>
                            )}
                            {MatchPermission(["Create WorkFlow"]) ?
                                companyInfoGlobal.workflow == 1 ?
                                    <div className='mt-2 d-flex justify-content-center'>
                                        <button onClick={handleShowCreateWorkFlowModal} className='btn btn-exp-green btn-sm m-auto'>
                                            <i className="fas fa-project-diagram me-2" />
                                            Create
                                        </button>
                                    </div> : ""
                                : ""}
                        </>

                    }
                </div>
            </div>
            <Modal id="CreateWorkFlowModal" show={showCreateWorkFlowModal} onHide={handleCloseCreateWorkFlowModal} backdrop="static" centered size="lg">
                <Modal.Header closeButton className="gth-blue-light-bg">
                    <Modal.Title className="gth-modal-title">Create New Workflow <small>(Dependent Task)</small></Modal.Title>
                </Modal.Header>
                <form onSubmit={CreateFlow}>
                    <Modal.Body className="pb-0">
                        <div className="row">
                            <div className="col-sm-6 col-12">
                                <div className="form-group">
                                    {/* <label className="form-label">Dependent Task Name <span className="gth-text-danger">*</span></label> */}
                                    <input type="text" required className="form-control" placeholder="Dependent Task Name (What)" value={FlowData.name} onChange={(e) => setFlowData({ ...FlowData, name: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6 col-12">
                                <div className="form-group">
                                    {/* <label className="form-label">Permission user for task add</label> */}
                                    <div className='custom-select-wrap'>
                                        <Select
                                            name='selectMultipleDoers'
                                            options={User}
                                            placeholder="Assign To (Who)"
                                            // value={selectedOptions}
                                            getOptionLabel={(option) => option.name}
                                            getOptionValue={(option) => option.id}
                                            isMulti
                                            theme={(theme) => ({
                                                ...theme,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: '#ddddff',
                                                    primary: '#6161ff',
                                                },
                                            })}
                                            onChange={(selectedOptions) => {
                                                const selectedValues = selectedOptions ? selectedOptions.map(option => option.id) : [];
                                                const MultiDoers = JSON.stringify(selectedValues);
                                                setFlowData({ ...FlowData, permission_user: MultiDoers })
                                                // setFmsStep(prevSteps =>
                                                //     prevSteps.map(step =>
                                                //         step.id === id ? { ...step, doers: MultiDoers } : step
                                                //     )
                                                // )
                                            }}
                                            styles={{
                                                menu: (base) => ({
                                                    ...base,
                                                    backgroundColor: isDarkTheme ? "#06162f" : "#ffffff",
                                                    color: isDarkTheme ? "#e0e0e0" : "#000000",
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: isDarkTheme ? "#e0e0e0" : "#000000",
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.isFocused ? (isDarkTheme ? "#112a46" : "#ddddff") : "transparent",
                                                    color: isDarkTheme ? "#e0e0e0" : "#000000",
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-12'>
                                <div className='form-group'>
                                    {/* <label className='form-label'>Description</label> */}
                                    {/* <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: {
                                                items: [
                                                    'heading', '|',
                                                    'bold', 'italic', 'link', '|',
                                                    'bulletedList', 'numberedList', '|',
                                                    'blockQuote', '|',
                                                    'undo', 'redo',
                                                ]
                                            }
                                        }}
                                        onChange={(event, editor) => setFlowData({ ...FlowData, desc: editor.getData() })}
                                    /> */}
                                    <textarea
                                        className="form-control"
                                        rows={3}
                                        placeholder="Description"
                                        value={FlowData.desc}
                                        onChange={e => setFlowData({ ...FlowData, desc: e.target.value })}
                                    />
                                </div>
                            </div>
                            {/* <div className='col-12'>
                                            <div className='form-group'>
                                                <label className='form-label'>SOP Video Link</label>
                                                <input type="text" className="form-control" value={FlowData.link} onChange={(e) => setFlowData({ ...FlowData, link: e.target.value })} />
                                            </div>
                                        </div> */}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type='submit' className="btn btn-exp-green" >
                            Create
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    );
}

export default WorkflowChart;



